// Notes From Me! small enhancements layered on Dawn.
// 1. Reveal-on-scroll for [data-nm-reveal]
// 2. Shrinking sticky header (adds .is-scrolled to .section-header when window scrollY > 8)

(function () {
  'use strict';

  function setupReveal() {
    var items = document.querySelectorAll('[data-nm-reveal]');
    if (!items.length || !('IntersectionObserver' in window)) {
      items.forEach(function (el) { el.classList.add('is-visible'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          io.unobserve(entry.target);
        }
      });
    }, { rootMargin: '0px 0px -10% 0px', threshold: 0.05 });
    items.forEach(function (el) { io.observe(el); });
  }

  function setupStickyHeader() {
    var header = document.querySelector('.section-header');
    if (!header) return;
    var onScroll = function () {
      if (window.scrollY > 8) header.classList.add('is-scrolled');
      else header.classList.remove('is-scrolled');
    };
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      setupReveal();
      setupStickyHeader();
    });
  } else {
    setupReveal();
    setupStickyHeader();
  }
})();
